module.exports = __webpack_public_path__ + "img/nathan.af744fd9.png";